import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massDestroyContacts } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useDeleteAllContacts = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ items }) => massDestroyContacts(items || []),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Messages deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete messages';
            toast.error(errorMessage);
        },
    });
};